// extracted by mini-css-extract-plugin
export default {"sneakersContainer":"Sneakers_sneakersContainer__9nzZL","sneakersHeader":"Sneakers_sneakersHeader__J1tmH","sneakersSection":"Sneakers_sneakersSection__iqImS"};